import React from 'react';

const FeedEntityContext = React.createContext();
// Context object accepts a displayName string property.
// React DevTools uses this string to determine what to display for the context.
FeedEntityContext.displayName = 'FeedEntityContext';

export function useFeedEntityContext() {
  return React.useContext(FeedEntityContext);
}

export default FeedEntityContext;
